import app from '../../../browser/addform/scripts/app';
import { react2angular } from 'react2angular';
import { CommunicationTypeContainer } from './CommunicationType.container';

app.component(
  'communicationType',
  react2angular(
    CommunicationTypeContainer,
    ['changeCommunicationType', 'getCommunicationType'],
    ['config', 'httpApi', 'logger'],
  ),
);
